import React from "react";
import "../css/EventsActivitie.css";
import { Link } from "react-router-dom";

const EventsActivities = () => {
  const eventImg = "./images/b.jpeg";

  return (
    <section className="events-section-container">
      <div className="events-main-card">
        <div className="events-flex-layout">
          {}
          <div className="events-image-box">
            <img
              src={eventImg}
              alt="School Events and Activities"
              className="events-hero-img"
            />
          </div>

          {}
          <div className="events-info-box">
            <div className="events-green-header">
              <h2>Events and Activities</h2>
            </div>

            <div className="events-content-body">
              <p className="events-desc-text">
                Throughout the year, our teachers and administrators plan events
                and activities that allow our students to feel connected and
                engaged with our larger community. These events and activities
                are an opportunity for parents, students and educators to come
                together and enjoy themselves while still working toward
                fulfilling our mission as a leader in global education.
              </p>

            <Link to="/events&activities" className="btn btn-primary">
  READ MORE <i>›</i>
</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsActivities;
